<template>
  <dashboard>
    <template v-slot:content>
      <loading v-show="!loading" />
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <!-- <b-col lg="12" md="12"> -->
              <!-- <b-row class> -->
              <b-col md="8">
                <div class="float-left">
                  <h5 class="mt-2 mr-3" v-if="batchView == true">
                    Batch Confirmation
                  </h5>
                  <h5 class="mt-2 mr-3" v-else>Order Confirmation</h5>
                </div>
                <div
                  class="cart-mode float-right batch-info"
                  v-if="batchView == true"
                >
                  <b-tabs pills card class="">
                    <b-tab title="View by Orders"></b-tab>
                    <b-tab title="View by Batches"></b-tab>
                  </b-tabs>
                </div>
              </b-col>
              <b-col md="4">
                <div class="d-flex header-btns float-right">
                  <b-button
                    variant="outline-primary"
                    class="mr-2"
                    :disabled="$loading"
                    @click="cancelConfirmOrder"
                    >Back</b-button
                  >
                  <!-- <b-button disabled="" v-if="batchView == true">Confirm Batch</b-button> -->
                  <b-button
                    @click="confirmOrder()"
                    variant="primary"
                    :disabled="confirmBtnVal || $loading || list.length == 0"
                    >Confirm Order</b-button
                  >
                </div>
              </b-col>

              <!-- </b-row> -->
              <!-- </b-col> -->
            </b-row>
          </div>
        </b-container>
      </section>

      <section>
        <b-container fluid>
          <div class="table-dark-bg box-shadow mt-2 ">
            <!-- Inventory avaliable message-->
            <p
              class="ml-4 mt-4 text-success fs-14"
              v-if="
                list.length !== 0 && availableProduct.length === list.length
              "
            >
              <!-- <font-awesome-layers> -->
              <font-awesome-icon :icon="['fas', 'check-circle']" class="mr-2" />
              Inventory available for all {{ list.length }} products in the
              order.
              <!-- </font-awesome-layers> -->
            </p>
            <!-- <b-link title="Request Replenishment" class="float-right mt-4 mr-3">
              <img src="../assets/images/icon_request.svg" alt=" " /> Request
              Replenishment
            </b-link> -->
            <b-tabs pills class="confirmation-tabs" v-if="batchView == true">
              <b-tab
                :title="
                  'Orders with unavailable inventory (' + orders.length + ')'
                "
                active
              >
                <div class="heading" style="height:79vh">
                  <ul class="batch-header py-2 list-inline fs-11 mb-0">
                    <li>&nbsp;</li>
                    <li>Order Number</li>
                    <li>Time</li>
                    <li>Customer Name</li>
                    <li>Source</li>
                    <li># Products Short</li>
                    <li>&nbsp;</li>
                  </ul>
                  <div class="pill py-3 mb-2">
                    <ul class="batch-header list-inline fs-12 py-2 mb-0">
                      <li>
                        <font-awesome-icon
                          :icon="['fas', 'angle-up']"
                          class="icon"
                          v-b-toggle="'collapse-1'"
                        />
                      </li>
                      <li>OD12345678901234</li>
                      <li>01 Aug 2020 10:00:00</li>
                      <li>James Buchanan Barnes</li>
                      <li>Amazon</li>
                      <li>3/4</li>
                      <li>
                        <b-link class="text-blue action-btns px-3 py-2">
                          <img
                            src="../assets/images/icon_skip.svg"
                            alt=" "
                            @click="skipPopUp"
                          />
                          Skip Order</b-link
                        >
                      </li>
                    </ul>
                    <b-collapse id="collapse-1">
                      <b-table
                        :items="orders"
                        :fields="fields"
                        class="order-table mt-3 mb-0"
                        :tbody-tr-class="rowClass"
                        no-select-on-click
                        borderless
                        dark
                      >
                        <template v-slot:cell(index)="data">
                          {{ data.index + 1 }}
                        </template>
                        <template v-slot:cell(available_qty)="data">
                          {{
                            data.item.hasOwnProperty("available_qty")
                              ? data.item.available_qty
                              : "0"
                          }}
                        </template>
                        <template v-slot:cell(actions)="">
                          <b-link
                            class="text-blue action-btns px-3 py-2"
                            @click="replacePopUp"
                            :disabled="
                              !omsSettings.is_replaced ||
                                omsInventoryBlockingLevel ||
                                data.item.is_discarded
                            "
                          >
                            <font-awesome-icon
                              :icon="['fas', 'exchange-alt']"
                            />
                            Replace</b-link
                          >:
                          <b-link
                            class="text-danger action-btns px-3 py-2"
                            @click="discardPopUp"
                            :disabled="
                              !omsSettings.is_discard ||
                                omsInventoryBlockingLevel ||
                                data.item.is_discarded
                            "
                          >
                            <font-awesome-icon :icon="['fas', 'times']" />
                            Discard</b-link
                          >
                        </template>
                      </b-table>
                    </b-collapse>
                  </div>
                  <div class="pill py-3 mb-2">
                    <ul class="batch-header list-inline fs-12 py-2 mb-0">
                      <li>
                        <font-awesome-icon
                          :icon="['fas', 'angle-up']"
                          class="icon"
                          v-b-toggle="'collapse-2'"
                        />
                      </li>
                      <li>OD12345678901234</li>
                      <li>01 Aug 2020 10:00:00</li>
                      <li>James Buchanan Barnes</li>
                      <li>Amazon</li>
                      <li>3/4</li>
                      <li>
                        <b-link
                          class="text-blue action-btns px-3 py-2"
                          @click="skipPopUp"
                        >
                          <img src="../assets/images/icon_skip.svg" alt=" " />
                          Skip Order</b-link
                        >
                      </li>
                    </ul>
                    <b-collapse id="collapse-2">
                      <b-table
                        :items="orders"
                        :fields="fields"
                        class="order-table mt-3 mb-0"
                        :tbody-tr-class="rowClass"
                        borderless
                        dark
                      >
                        <template v-slot:cell(index)="data">
                          {{ data.index + 1 }}
                        </template>
                        <template v-slot:cell(available_qty)="data">
                          {{
                            data.item.hasOwnProperty("available_qty")
                              ? data.item.available_qty
                              : "0"
                          }}
                        </template>
                        <template v-slot:cell(actions)="">
                          <b-link
                            class="text-blue action-btns px-3 py-2"
                            @click="replacePopUp"
                            :disabled="
                              !omsSettings.is_replaced ||
                                omsInventoryBlockingLevel ||
                                data.item.is_discarded
                            "
                          >
                            <font-awesome-icon
                              :icon="['fas', 'exchange-alt']"
                            />
                            Replace</b-link
                          >
                          <b-link
                            class="text-danger action-btns px-3 py-2"
                            @click="discardPopUp"
                            :disabled="
                              !omsSettings.is_discard ||
                                omsInventoryBlockingLevel ||
                                data.item.is_discarded
                            "
                          >
                            <font-awesome-icon :icon="['fas', 'times']" />
                            Discard</b-link
                          >
                        </template>
                      </b-table>
                    </b-collapse>
                  </div>
                </div>
              </b-tab>
              <b-tab
                :title="
                  'Orders with available inventory (' +
                    ordersAvaliable.length +
                    ')'
                "
              >
                <b-table
                  :items="ordersAvaliable"
                  :fields="fields"
                  class="order-table"
                  :tbody-tr-class="rowClass"
                  borderless
                  dark
                >
                  <template v-slot:cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template v-slot:cell(available_qty)="data">
                    {{
                      data.item.hasOwnProperty("available_qty")
                        ? data.item.available_qty
                        : "0"
                    }}
                  </template>
                  <template v-slot:cell(actions)="">
                    <b-link
                      class="text-blue action-btns px-3 py-2"
                      @click="replacePopUp"
                      :disabled="
                        !omsSettings.is_replaced ||
                          omsInventoryBlockingLevel ||
                          data.item.is_discarded
                      "
                    >
                      <font-awesome-icon :icon="['fas', 'exchange-alt']" />
                      Replace</b-link
                    >
                    <b-link
                      class="text-danger action-btns px-3 py-2"
                      @click="discardPopUp"
                      :disabled="
                        !omsSettings.is_discard ||
                          omsInventoryBlockingLevel ||
                          data.item.is_discarded
                      "
                    >
                      <font-awesome-icon :icon="['fas', 'times']" />
                      Discard</b-link
                    >
                  </template>
                </b-table>
              </b-tab>
            </b-tabs>
            <b-tabs
              v-model="tabActive"
              pills
              class="confirmation-tabs"
              :nav-class="
                availableProduct.length === list.length ? 'd-none' : ''
              "
              v-else
            >
              <b-tab
                v-if="list.length !== 0 && unavailableProduct.length !== 0"
                :title="
                  `Products with unavailable inventory (${unavailableProduct.length})`
                "
              >
                <b-table
                  :items="unavailableProduct"
                  :fields="fields"
                  class="order-table"
                  :tbody-tr-class="rowClass"
                  borderless
                  dark
                >
                  <template v-slot:cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template v-slot:cell(item_name)="data">
                    <span
                      v-b-tooltip.hover
                      :title="data.item.item_name"
                      v-text="trimProductName(data.item.item_name)"
                    />
                  </template>
                  <template v-slot:cell(unit_mrp)="data">
                    <span
                      v-text="currencySymbol + formatAmount(data.item.unit_mrp)"
                    />
                  </template>
                  <template v-slot:cell(total_discount)="data">
                    <span
                      v-text="
                        currencySymbol + formatAmount(data.item.total_discount)
                      "
                    />
                  </template>
                  <template v-slot:cell(tax)="data">
                    <span
                      v-text="currencySymbol + formatAmount(data.item.tax)"
                    />
                  </template>
                  <template v-slot:cell(total)="data">
                    <span
                      v-text="currencySymbol + formatAmount(data.item.total)"
                    />
                  </template>
                  <template v-slot:cell(available_qty)="data">
                    {{
                      data.item.hasOwnProperty("available_qty")
                        ? data.item.available_qty
                        : "0"
                    }}
                  </template>
                  <template v-slot:cell(info)="data">
                    <div v-b-tooltip.hover :title="data.item.message">
                      <font-awesome-icon
                        icon="info-circle"
                        class="text-danger"
                      />
                    </div>
                  </template>
                  <template v-slot:cell(actions)="data">
                    <b-link
                      class="text-blue action-btns px-3 py-2"
                      @click="replacePopUp(data.item)"
                      v-show="!data.item.is_discarded"
                      :disabled="
                        omsInventoryBlockingLevel || data.item.is_discarded
                      "
                    >
                      <font-awesome-icon :icon="['fas', 'exchange-alt']" />
                      Replace</b-link
                    >
                    <b-link
                      class="text-danger action-btns px-3 py-2"
                      @click="discardPopUp(data.item)"
                      :disabled="
                        omsInventoryBlockingLevel || data.item.is_discarded
                      "
                      v-show="!data.item.is_discarded"
                    >
                      <font-awesome-icon :icon="['fas', 'times']" />
                      Discard</b-link
                    >
                    <b-link
                      class="text-success action-btns px-3 py-2"
                      @click="keepPopUp(data.item)"
                      v-show="data.item.is_discarded"
                    >
                      <font-awesome-icon :icon="['fas', 'check']" />
                      Keep</b-link
                    >
                  </template>
                </b-table>
              </b-tab>
              <b-tab
                v-if="list.length !== 0 && availableProduct.length !== 0"
                :title="
                  `Products with available inventory (${availableProduct.length})`
                "
              >
                <b-table
                  :items="availableProduct"
                  :fields="fields"
                  class="order-table"
                  :tbody-tr-class="rowClass"
                  borderless
                  dark
                >
                  <template v-slot:cell(index)="data">
                    {{ data.item.is_discarded ? "-" : data.index + 1 }}
                  </template>
                  <template v-slot:cell(item_name)="data">
                    <span
                      v-b-tooltip.hover
                      :title="data.item.item_name"
                      v-text="trimProductName(data.item.item_name)"
                    />
                  </template>
                  <template v-slot:cell(unit_mrp)="data">
                    <span
                      v-text="currencySymbol + formatAmount(data.item.unit_mrp)"
                    />
                  </template>
                  <template v-slot:cell(total_discount)="data">
                    <span
                      v-text="
                        currencySymbol + formatAmount(data.item.total_discount)
                      "
                    />
                  </template>
                  <template v-slot:cell(tax)="data">
                    <span
                      v-text="currencySymbol + formatAmount(data.item.tax)"
                    />
                  </template>
                  <template v-slot:cell(total)="data">
                    <span
                      v-text="currencySymbol + formatAmount(data.item.total)"
                    />
                  </template>
                  <template v-slot:cell(available_qty)="data">
                    {{
                      data.item.hasOwnProperty("available_qty")
                        ? data.item.available_qty
                        : "0"
                    }}
                  </template>
                  <template v-slot:cell(info)="data">
                    <font-awesome-icon
                      v-show="data.item.is_sellable"
                      icon="check-circle"
                      class="text-success"
                    />
                  </template>
                  <template v-slot:cell(actions)="data">
                    <b-link
                      class="text-blue action-btns px-3 py-2"
                      @click="replacePopUp(data.item)"
                      v-show="!data.item.is_discarded"
                      :disabled="
                        omsInventoryBlockingLevel || data.item.is_discarded
                      "
                    >
                      <font-awesome-icon :icon="['fas', 'exchange-alt']" />
                      Replace</b-link
                    >
                    <b-link
                      class="text-danger action-btns px-3 py-2"
                      @click="discardPopUp(data.item)"
                      v-show="!data.item.is_discarded"
                      :disabled="
                        omsInventoryBlockingLevel || data.item.is_discarded
                      "
                    >
                      <font-awesome-icon :icon="['fas', 'times']" />
                      Discard</b-link
                    >
                    <b-link
                      class="text-success action-btns px-3 py-2"
                      @click="keepPopUp(data.item)"
                      v-show="data.item.is_discarded"
                    >
                      <font-awesome-icon :icon="['fas', 'check']" />
                      Keep</b-link
                    >
                  </template>
                </b-table>
              </b-tab>
            </b-tabs>
          </div>

          <!-- Modal for Skip Product-->
          <b-modal
            ref="skip-orders"
            id="skip-orders"
            size="sm"
            hide-footer
            hide-header
            centered
          >
            <h6 class="mb-3 fw-normal">
              <img src="../assets/images/alert.svg" class="mr-1" /> Skip Orders
            </h6>
            <p>
              Are you sure you wish to skip the selected order and remove it
              from the batch?
            </p>
            <p>You can later find it among other pending orders.</p>
            <b-row class="mt-4">
              <b-col md="6">
                <b-button
                  variant="outline-primary"
                  block
                  class="px-4"
                  @click="$bvModal.hide('skip-orders')"
                  v-shortkey="['esc']"
                  @shortkey="$bvModal.hide('skip-orders')"
                >
                  Cancel
                </b-button>
              </b-col>
              <b-col md="6" class="pl-0">
                <b-button
                  block
                  class="px-4"
                  @click="discardProduct()"
                  variant="danger"
                >
                  <span v-if="$loading == false">Skip</span>
                </b-button>
              </b-col>
            </b-row>
          </b-modal>

          <!-- Modal for Discard Product-->
          <b-modal
            ref="discard-product"
            id="discard-product"
            size="sm"
            hide-footer
            hide-header
            centered
          >
            <h6 class="mb-3 fw-normal">
              <!-- <img src="../assets/images/alert.svg" class="mr-1" /> -->
              <span
                v-text="
                  keep
                    ? 'Keep Product'
                    : getListCount
                    ? 'Cancel Order'
                    : 'Discard Product'
                "
              />
            </h6>
            <p>
              Are you sure you wish to
              <span v-text="keep ? 'keep' : 'discard'" /> the selected product?
            </p>
            <div v-show="!keep">
              <p>
                <span v-show="getListCount">
                  Order will be cancelled and the customer will be refunded with
                  the paid amount
                  <span
                    v-show="
                      (omsSettings.refund_mode.cash &&
                        !omsSettings.refund_mode.credit_note) ||
                        (!omsSettings.refund_mode.cash &&
                          omsSettings.refund_mode.credit_note)
                    "
                    v-text="
                      ` by: ${
                        omsSettings.refund_mode.cash ? 'Cash' : 'Store Credit'
                      }`
                    "
                /></span>
                <span v-show="!getListCount">
                  It will be removed from the order and the customer will be
                  notified about the change.
                </span>
              </p>
              <b-form-group
                class="mt-2"
                v-if="
                  getListCount &&
                    omsSettings.refund_mode.cash &&
                    omsSettings.refund_mode.credit_note
                "
              >
                <small for="refund-type">Select Mode of Refund</small>
                <b-form-radio-group
                  id="invoice_type"
                  v-model="orderRefund.type"
                  :options="orderRefund.options"
                  name="radio-options"
                  class="mt-2 mb-2"
                  style="padding-bottom: 8px;"
                />
              </b-form-group>
            </div>
            <p v-show="keep">
              It will be added to the order and the customer will be notified
              about the change.
            </p>
            <b-row class="mt-4">
              <b-col md="6">
                <b-button
                  block
                  class="px-4"
                  variant="outline-primary"
                  @click="
                    $bvModal.hide('discard-product'),
                      (removeProduct = ''),
                      (keep = false)
                  "
                  :disabled="$loading"
                  v-shortkey="['esc']"
                  @shortkey="$bvModal.hide('discard-product')"
                >
                  Cancel
                </b-button>
              </b-col>
              <b-col md="6" class="pl-0">
                <b-button
                  block
                  class="px-4"
                  @click="discardProduct(getListCount && !keep ? 'cancel' : '')"
                  variant="primary"
                  :disabled="$loading"
                >
                  <span
                    v-if="!$loading"
                    v-text="
                      keep ? 'Keep' : getListCount ? 'Continue' : 'Discard'
                    "
                  />
                  <b-spinner small v-if="$loading" />
                </b-button>
              </b-col>
            </b-row>
          </b-modal>

          <!-- Modal for replace product -->
          <b-modal
            ref="replace-product"
            id="replace-product"
            no-close-on-backdrop
            no-close-on-esc
            size="xl"
            hide-footer
            hide-header
            centered
            @hide="hideReplaceProductModal"
          >
            <b-row>
              <b-col md="8">
                <h6 class="mb-3 fw-normal">
                  Replace Product
                </h6>
              </b-col>
              <b-col md="4">
                <b-input-group size="md" class="box-shadow">
                  <b-form-input
                    v-model="barcode"
                    placeholder="Scan or enter barcode..."
                    v-on:keyup.enter="
                      getProductDetails($event.target.value),
                        (isHide = false),
                        (searchResponseList = []),
                        (barcode = '')
                    "
                    @keyup.esc="cancelSearch"
                    class="search"
                    @keyup="productSearch"
                    autocomplete="off"
                    v-shortkey.focus="['ctrl', 's']"
                    autofocus
                    ref="search"
                  />
                  <b-input-group-text slot="append" class="search-icon">
                    <font-awesome-icon :icon="['fas', 'search']" />
                  </b-input-group-text>
                </b-input-group>
                <!-- Auto Suggestion -->
                <transition name="slide">
                  <div class="product-search" v-show="isHide">
                    <div class="box-shadow">
                      <ul
                        id="product-list"
                        v-if="searchResponseList.length !== 0"
                      >
                        <li
                          v-for="item in searchResponseList"
                          :key="item.index"
                          class="get-product"
                          @click="getProductDetails(item)"
                        >
                          <b-row>
                            <b-col md="8">
                              <h6 v-text="item.name" class="mb-0" />
                            </b-col>
                            <b-col md="4">
                              <span
                                v-text="currencySymbol + formatAmount(item.mrp)"
                              />
                            </b-col>
                          </b-row>
                        </li>
                      </ul>
                      <div
                        class="row align-items-center notification"
                        style="height:100%"
                        v-else
                      >
                        <h6 class="text-center w-100">No product found.</h6>
                      </div>
                    </div>
                  </div>
                </transition>
              </b-col>
              <b-col md="12" class="mt-2">
                <p class="fs-12 mb-4">
                  Scan or search for a product to replace the current product.
                  You cannot undo this action.
                </p>
                <p class="mt-3 mb-2 text-primary">Current Product</p>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col>
                <label class="pl-0">Barcode</label>
                <p v-text="currentProduct.barcode" />
              </b-col>
              <b-col cols="2">
                <label class="pl-0">Product</label>
                <p v-text="currentProduct.item_name" />
              </b-col>
              <b-col>
                <label class="pl-0">Unit Price</label>
                <p
                  v-text="
                    currencySymbol + formatAmount(currentProduct.unit_mrp)
                  "
                />
              </b-col>
              <b-col>
                <label class="pl-0">Total Discount</label>
                <p
                  v-text="
                    currencySymbol + formatAmount(currentProduct.total_discount)
                  "
                />
              </b-col>
              <b-col>
                <label class="pl-0">Total Taxes</label>
                <p v-text="currencySymbol + formatAmount(currentProduct.tax)" />
              </b-col>
              <b-col>
                <label class="pl-0">Total Amount</label>
                <p
                  v-text="currencySymbol + formatAmount(currentProduct.total)"
                />
              </b-col>
              <b-col>
                <label class="pl-0">Ordered Units</label>
                <p v-text="currentProduct.qty" />
              </b-col>
              <b-col>
                <label class="pl-0">Units Available</label>
                <p
                  :class="[
                    currentProduct.available_qty < 0
                      ? 'text-danger'
                      : 'text-muted',
                  ]"
                  v-text="
                    currentProduct.hasOwnProperty('available_qty')
                      ? currentProduct.available_qty
                      : '0'
                  "
                ></p>
              </b-col>
              <b-col>
                &nbsp;
              </b-col>
            </b-row>

            <b-link class="mt-3 mb-2 text-blue">Replacement Product</b-link>
            <p
              class="mt-3 text-muted"
              v-if="Object.keys(replaceProduct).length === 0"
            >
              Scan a product to view its information
            </p>

            <b-row
              class="mb-3 mt-2"
              v-if="Object.keys(replaceProduct).length !== 0"
            >
              <b-col>
                <label class="pl-0">Barcode</label>
                <p v-text="replaceProduct.barcode" />
              </b-col>
              <b-col cols="2">
                <label class="pl-0">Product</label>
                <p v-text="replaceProduct.item_name" />
              </b-col>
              <b-col>
                <label class="pl-0">Unit Price</label>
                <p
                  v-text="
                    currencySymbol + formatAmount(replaceProduct.unit_mrp)
                  "
                />
              </b-col>
              <b-col>
                <label class="pl-0">Total Discount</label>
                <p
                  v-text="
                    currencySymbol + formatAmount(replaceProduct.total_discount)
                  "
                />
              </b-col>
              <b-col>
                <label class="pl-0">Total Taxes</label>
                <p v-text="currencySymbol + formatAmount(replaceProduct.tax)" />
              </b-col>
              <b-col>
                <label class="pl-0">Total Amount</label>
                <p
                  v-text="currencySymbol + formatAmount(replaceProduct.total)"
                />
              </b-col>
              <b-col>
                <label class="pl-0">Ordered Units</label>
                <p
                  v-text="parseFloat(replaceProduct.qty).toFixed(2)"
                  v-if="replaceProduct.weight_flag"
                />
                <select
                  class="custom-select custom-select-sm"
                  @change="updateQty($event.target.value)"
                  v-if="!replaceProduct.weight_flag"
                >
                  <option
                    v-for="(nqty, index) in parseInt(
                      replaceProduct.available_qty
                    )"
                    v-bind:key="index"
                    v-text="nqty"
                    :value="nqty"
                    :selected="nqty == replaceProduct"
                    :id="'order-replace-' + index"
                  />
                </select>
              </b-col>
              <b-col>
                <label class="pl-0">Units Available</label>
                <p
                  :class="[
                    replaceProduct.available_qty < 0
                      ? 'text-danger'
                      : 'text-success',
                  ]"
                  v-text="
                    replaceProduct.hasOwnProperty('available_qty')
                      ? replaceProduct.available_qty
                      : '0'
                  "
                />
              </b-col>
              <b-col>
                &nbsp;
              </b-col>
            </b-row>

            <b-row class="mt-4">
              <b-col md="2" offset-md="8" class="pr-1">
                <b-button
                  block
                  @click="$bvModal.hide('replace-product')"
                  v-shortkey="['esc']"
                  @shortkey="$bvModal.hide('replace-product')"
                  :disabled="$loading"
                  variant="outline-primary"
                  >Dismiss
                </b-button>
              </b-col>
              <b-col md="2" class="pl-0">
                <b-button
                  block
                  variant="primary"
                  :disabled="
                    Object.keys(replaceProduct).length === 0 || $loading
                  "
                  @click="confirmReplaceProduct"
                >
                  <span v-if="!$loading">Replace</span>
                  <b-spinner small v-else></b-spinner>
                </b-button>
              </b-col>
            </b-row>
          </b-modal>
        </b-container>
      </section>
      <b-modal
        title="Change in Order Amount"
        centered
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        size="sm"
        ref="order-confirm-warning"
        id="order-confirm-warning"
      >
        <b-row v-if="orderAction.type == 'lower'">
          <b-col md="12">
            <p>
              Due to changes made to the order, the amount has been reduced by
              <span
                v-text="
                  `${currencySymbol}${formatAmount(orderAction.refundAmt)}`
                "
              />
            </p>
          </b-col>
          <b-col
            md="12"
            v-if="
              omsSettings.refund_mode.cash &&
                omsSettings.refund_mode.credit_note
            "
          >
            <p class="mt-2">
              How do you wish to refund the amount to the customer?
            </p>
            <b-form-group class="mt-2">
              <small for="refund-type">Select Mode of Refund</small>
              <b-form-radio-group
                id="invoice_type"
                v-model="orderRefund.type"
                :options="orderRefund.options"
                name="radio-options"
                class="mt-2 mb-2"
                style="padding-bottom: 8px;"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" v-else>
            <p
              class="mt-2"
              v-text="
                `The amount will be refunded to the customer by: ${
                  omsSettings.refund_mode.cash ? 'Cash' : 'Store Credit'
                }`
              "
            />
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col md="12">
            <p>
              Due to changes made to the order, the amount has been increased by
              <span
                v-text="
                  `${currencySymbol}${formatAmount(orderAction.refundAmt)}`
                "
              />
            </p>
            <p>
              This amount will be reflected in the 'Amount Due' section in order
              summary, payment for which can be collected before generating
              invoice.
            </p>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col md="6" class="pr-1">
            <b-button
              block
              :disabled="$loading"
              variant="outline-primary"
              @click="$refs['order-confirm-warning'].hide()"
              >Close</b-button
            >
          </b-col>
          <b-col md="6" class="pl-1">
            <b-button
              @click="
                confirmOrder(
                  orderAction.type == 'lower' ? orderRefund.type : 'greater'
                )
              "
              block
              :disabled="$loading"
              variant="primary"
            >
              <span v-if="!$loading">Confirm</span>
              <b-spinner small v-else />
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <select-batch-modal
        :open="openBatchSelectModal"
        :options="batchList"
        :barcode="selectedBarcode"
        :batch="''"
        @close-batch-modal="openBatchSelectModal = false"
        @update-batch="updateBatch"
        :type="invType"
      />
    </template>
  </dashboard>
</template>

<script>
import Dashboard from "../views/Dashboard";
import Loading from "../components/Loading";
import axios from "axios";
import { mapState } from "vuex";
import { STOCK_UNAVAILABLE, REPLACE_SUCCESS, SAME_BARCODE } from "../message";
import SelectBatchModal from "../components/SelectBatchModal";

export default {
  name: "order-confirmation",
  components: {
    Dashboard,
    Loading,
    SelectBatchModal,
  },
  props: ["order_id"],
  created() {
    this.getOrderData();
  },
  // beforeDestroy() {
  //   this.$store.commit("billing/setTransactionSubType", "");
  // },
  beforeRouteLeave(to, from, next) {
    if (
      this.state.billing.trans_sub_type == "order" &&
      ![`/order-summary/${this.order_id}`].includes(to.path)
    )
      this.$store.commit("billing/setTransactionSubType", "");
    next();
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    availableProduct() {
      return this.list.filter((item) => item.is_available === true);
    },
    unavailableProduct() {
      return this.list.filter((item) => item.is_available !== true);
    },
    omsSettings() {
      return this.$store.getters["omsSettings"];
    },
    omsInventoryBlockingLevel() {
      return (
        this.$store.getters["omsInventoryBlockingLevel"] == "order_created"
      );
    },
    // checkDiscardedProducts() {
    //   let temp = true;
    //   let discarded = [];
    //   if (this.list.length == 1) return temp;
    //   this.list.forEach((item) => {
    //     if (item.is_discarded) discarded.push(item);
    //   });
    //   let diff = this.list.length - discarded.length;
    //   if (diff >= 2) temp = false;

    //   return temp;
    // },
    confirmBtnVal() {
      let temp = true;
      let avalKeep = this.availableProduct.filter((i) => !i.is_discarded);
      let notDiscardedProducts = this.list.filter((i) => !i.is_discarded);
      let invBlockLevel = this.$store.getters["omsInventoryBlockingLevel"];
      if (["order_packed", "invoice_generated"].includes(invBlockLevel)) {
        if (notDiscardedProducts.length > 0) temp = false;
      } else {
        if (this.unavailableProduct.length == this.list.length) return true;
        let avalDisc = this.availableProduct.filter((i) => i.is_discarded);
        let unaval = this.unavailableProduct.filter((i) => i.is_discarded);
        if (avalKeep.length != 0) {
          let totInv = avalKeep.length + avalDisc.length + unaval.length;
          if (totInv == this.list.length) temp = false;
        }
      }
      return temp;
    },
    getListCount() {
      let data = this.list.filter((i) => i.is_discarded);
      return this.list.length - data.length == 1;
    },
  },
  data() {
    return {
      loading: true,
      isShow: false,
      show: false,
      batchView: false,
      Title: "Order Confirmation",
      showSearchTerm: false,
      onApiRequest: false,
      barcode: "",
      // fields: ['#', 'Barcode', 'Product','Unit Price','Total Discount','Total Taxes','Total Amount','Ordered Units','Units Available',''],
      fields: [
        {
          key: "index",
          label: "#",
          thStyle: { width: "5%" },
          class: "text-center",
        },
        { key: "barcode", label: "Barcode" },
        { key: "item_name", label: "Product" },
        { key: "unit_mrp", label: "Price" },
        { key: "total_discount", label: "Discount" },
        { key: "tax", label: "Taxes" },
        { key: "total", label: "Total" },
        { key: "qty", label: "Ordered Units", class: "text-center" },
        {
          key: "available_qty",
          label: "Units Available",
          class: "text-center",
        },
        {
          key: "info",
          label: "Info",
          class: "text-center",
        },
        {
          key: "actions",
          label: "",
          thStyle: { width: "20%" },
          class: "text-right",
        },
      ],
      list: [],
      tabActive: 1,
      removeProduct: "",
      currentProduct: {},
      replaceProduct: {},
      searchResponseList: [],
      isHide: false,
      userDetails: {},
      orderDetails: "",
      orignalList: [],
      keep: false,
      openBatchSelectModal: false,
      batchList: [],
      selectedBarcode: "",
      invType: "",
      replaceProductBatch: {},
      orderAction: {
        refundAmt: "",
        type: "",
      },
      orderRefund: {
        options: [
          { text: "Cash", value: "cash" },
          { text: "Store Credit", value: "credit" },
        ],
        type: "cash",
      },
    };
  },
  watch: {
    barcode() {
      if (this.barcode == "") {
        this.isHide = false;
      }
    },
  },
  mounted() {
    this.orderRefund.type = this.omsSettings.refund_mode.cash
      ? "cash"
      : "credit";
    return this.list.length === 0
      ? 1
      : this.list.unavailable.length !== 0
      ? 1
      : 2;
  },
  methods: {
    trimProductName(str) {
      let length = 4;
      let count = 0;
      let i = 0;
      for (i = 0; i < str.length; i++) {
        if (str[i] == " ") {
          count += 1;
          if (count == length) {
            break;
          }
        }
      }
      if (i != 0) {
        str = str.substring(0, i);
        return str + "...";
      } else {
        return str;
      }
    },
    skipPopUp() {
      this.$refs["skip-orders"].show();
    },
    discardPopUp(val) {
      if (!this.omsSettings.is_discard) {
        this.$store.commit("notifications/showAlert", {
          message: "Contact manager to enable this feature",
          type: "danger",
        });
        this.$showAlert = true;
        return;
      }
      this.keep = false;
      this.removeProduct = val;
      this.$refs["discard-product"].show();
    },
    discardProduct(action = "") {
      if (action == "cancel") return this.cancelOrder();
      if (this.keep) return this.keepPopUp({}, "confirm");
      let index = _.findIndex(this.list, {
        barcode: this.removeProduct.barcode,
      });
      this.list[index].is_discarded = true;
      let removedProduct = this.list.splice(index, 1);
      this.list.push(removedProduct[0]);
      this.$store.commit("notifications/showAlert", {
        message: `Product discarded successfully (${this.removeProduct.item_name})`,
        type: "success",
      });
      this.$showAlert = true;
      this.$refs["discard-product"].hide();
    },
    replacePopUp(val) {
      if (!this.omsSettings.is_replaced) {
        this.$store.commit("notifications/showAlert", {
          message: "Contact manager to enable this feature",
          type: "danger",
        });
        this.$showAlert = true;
        return;
      }
      this.currentProduct = val;
      this.barcode = "";
      this.$refs["replace-product"].show();
    },
    rowClass(item) {
      if (!item.is_available && !item.is_discarded) return "unavailable";
      if (item.is_available && !item.is_discarded) return "available";
      if (item.is_discarded) return "discarded";
    },
    cancelSearch() {
      this.barcode = "";
    },
    togglePill() {
      this.show = !this.show;
    },
    getOrderData() {
      this.$loading = true;
      let postData = {
        url: "/oms/get-order-details",
        order_id: this.order_id,
      };
      let data = Object.assign(postData, this.essentialsData);
      axios
        .post(data.url, data)
        .then((res) => {
          this.$loading = false;
          this.list = res.data.data;
          this.orignalList = _.cloneDeep(res.data.data);
          this.userDetails = res.data.user_details;
          this.orderDetails = res.data.order_details;
          // this.list["unavailable"] = res.data.data["unavailable"];
        })
        .catch(() => (this.$loading = false));
    },
    productSearch: _.debounce(function(event) {
      if (event.key == "Enter" || event.code == "Enter")
        return event.preventDefault();
      this.isHide = false;
      if (this.barcode == "") return;
      let data = {
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        search_term: this.barcode,
        url: "/product-search",
      };

      if (typeof this._source != typeof undefined) {
        this._source.cancel("Operation canceled due to new request.");
      }

      this._source = axios.CancelToken.source();

      axios
        .post(data.url, data, { cancelToken: this._source.token })
        .then((response) => {
          this.isHide = true;
          this.searchResponseList = response.data.data.data;
        })
        .catch((err) => {
          if (axios.isCancel(err)) {
            console.log("request canceled", err);
          }
          this.$loading = false;
        });
    }, 200),
    getProductDetails(val, from = "") {
      if (val == "") return;
      this.$loading = true;
      let postData = Object.assign(
        {
          barcode: val.barcode == undefined ? val : val.barcode,
          url: "/oms/get-product-details",
          qty:
            from == "updateQty"
              ? this.replaceProduct.qty
              : this.currentProduct.qty,
          comm_trans: this.userDetails.comm_trans,
          cust_gstin: this.userDetails.cust_gstin,
          type: from == "updateQty" ? "update" : "add",
          weight: val.weight_flag,
          from_screen: "confirm",
        },
        this.essentialsData
      );
      axios
        .post(postData.url, postData)
        .then((res) => {
          if (res.data.status == "fail") {
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", {
              message: res.data.data,
              type: "danger",
            });
          } else {
            if (
              postData.type == "add" &&
              this.currentProduct.original_barcode == res.data.data.barcode
            ) {
              this.$showAlert = true;
              this.$store.commit("notifications/showAlert", {
                message: SAME_BARCODE,
                type: "danger",
              });
              return;
            }
            if (
              (postData.type == "add" && res.data.data.batch.length > 0) ||
              (postData.type == "add" && res.data.data.serial.length > 0)
            ) {
              this.invType =
                res.data.data.batch.length > 0 ? "batch" : "serial";
              this.openBatchSelectModal = true;
              this.batchList =
                this.invType == "batch"
                  ? res.data.data.batch
                  : res.data.data.serial;
              this.selectedBarcode = res.data.data.barcode;
              this.replaceProductBatch = res.data.data;
              return;
            }
            if (res.data.data.is_available) this.replaceProduct = res.data.data;
            else {
              let alertData = {
                message: STOCK_UNAVAILABLE,
                type: "danger",
              };
              this.$showAlert = true;
              this.$store.commit("notifications/showAlert", alertData);
            }
          }
          this.$loading = false;
          this.isHide = false;
          this.barcode = "";
          this.searchResponseList = [];
        })
        .catch(() => (this.$loading = false));
    },
    hideReplaceProductModal() {
      this.replaceProduct = {};
      this.currentProduct = {};
      this.isHide = false;
      this.searchResponseList = [];
    },
    async confirmReplaceProduct() {
      this.$loading = true;
      this.list = await this.list.filter((item) => {
        let replacedBarcode = _.cloneDeep(this.currentProduct.barcode);
        if (this.currentProduct.barcode == item.barcode) {
          item.barcode = this.replaceProduct.barcode;
          item.qty = this.replaceProduct.qty;
          item.item_name = this.replaceProduct.item_name;
          item.unit_mrp = this.replaceProduct.unit_mrp;
          item.total_discount = this.replaceProduct.total_discount;
          item.tax = this.replaceProduct.tax;
          item.total = this.replaceProduct.total;
          item.stotal =
            parseFloat(this.replaceProduct.total) /
            parseFloat(this.replaceProduct.qty);
          item.subtotal =
            parseFloat(this.replaceProduct.unit_mrp) *
            parseFloat(this.replaceProduct.qty);
          item.ssubtotal =
            parseFloat(this.replaceProduct.unit_mrp) /
            parseFloat(this.replaceProduct.qty);
          item.id = this.replaceProduct.id;
          item.message = this.replaceProduct.message;
          item.is_sellable = this.replaceProduct.is_sellable;
          item.is_available = this.replaceProduct.is_available;
          item.available_qty = this.replaceProduct.available_qty;
          item.stock_point_name = this.replaceProduct.stock_point_name;
          item.weight_flag = this.replaceProduct.weight_flag;
          item.replaced = replacedBarcode;
          item.batch = this.checkEmpty(this.replaceProduct.batch_id)
            ? 0
            : this.replaceProduct.batch_id;
          item.serial = this.checkEmpty(this.replaceProduct.serial_id)
            ? 0
            : this.replaceProduct.serial_id;
        }
        return item;
      });
      this.$loading = false;
      this.$refs["replace-product"].hide();
      this.$store.commit("notifications/showAlert", {
        message: REPLACE_SUCCESS,
        type: "success",
      });
      this.$showAlert = true;
    },
    cancelConfirmOrder() {
      this.$router.push("/order-summary/" + this.order_id);
    },
    confirmOrder(via = "") {
      this.$loading = true;
      let productList = this.list.map((item) => {
        item.replaced = !this.checkEmpty(item.replaced)
          ? item.original_barcode
          : "";
        if (!item.is_discarded)
          return _.pick(item, [
            "barcode",
            "id",
            "qty",
            "tax",
            "total",
            "total_discount",
            "unit_mrp",
            "replaced",
            "batch",
            "serial",
          ]);
      });
      let postData = Object.assign(
        {
          product_list: JSON.stringify(productList),
          url: "/oms/confirm-order",
          order_id: this.order_id,
          comm_trans: this.userDetails.comm_trans,
          cust_gstin: this.userDetails.cust_gstin,
        },
        this.essentialsData
      );
      if (via != "") postData.via = via;
      axios
        .post(postData.url, postData)
        .then((res) => {
          if (res.data.status == "info") {
            this.$refs["order-confirm-warning"].show();
            this.orderAction.refundAmt = res.data.refund_amount;
            this.orderAction.type = res.data.type;
          } else if (res.data.status == "success") {
            if (via != "") this.$refs["order-confirm-warning"].hide();
            let alertData = {
              message: res.data.message,
              type: "success",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
            setTimeout(() => {
              this.$router.push("/order-summary/" + this.order_id);
            }, 100);
          }
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    updateQty(value) {
      this.replaceProduct.qty = value;
      this.getProductDetails(this.replaceProduct, "updateQty");
    },
    keepPopUp(prod = {}, status = "") {
      if (status == "") {
        this.keep = true;
        this.removedProduct = prod;
        this.$refs["discard-product"].show();
      } else {
        this.keep = false;
        this.list.forEach((i) => {
          if (i.barcode == this.removedProduct.barcode) i.is_discarded = false;
        });
        this.$refs["discard-product"].hide();
        this.$store.commit("notifications/showAlert", {
          message: `Product added successfully (${this.removeProduct.item_name})`,
          type: "success",
        });
        this.$showAlert = true;
      }
    },
    updateBatch(bdata) {
      let data = Object.assign(
        {
          url: "/oms/get-product-details-by-inventory",
          batch_id: this.invType == "batch" ? bdata.batch_data : "",
          serial_id: this.invType == "serial" ? bdata.batch_data : "",
          barcode: this.selectedBarcode,
          type: "add",
          comm_trans: this.userDetails.comm_trans,
          cust_gstin: this.userDetails.cust_gstin,
          qty: this.currentProduct.qty,
          weight: this.replaceProductBatch.weight_flag,
        },
        this.essentialsData
      );
      axios.post(data.url, data).then((res) => {
        if (res.data.status == "success") {
          this.openBatchSelectModal = false;
          this.barcode = "";
          this.invType = "";
          this.replaceProductBatch = {};
          this.replaceProduct = res.data.data;
        }
      });
    },
    cancelOrder() {
      let data = Object.assign(
        {
          order_id: this.order_id,
          remark: "Discarded from order confirm",
          url: "/oms/cancel-order",
          refund_via: this.orderRefund.type,
        },
        this.essentialsData
      );

      axios.post(data.url, data).then((res) => {
        if (res.data.status == "success") {
          this.$store.commit("notifications/showAlert", {
            message: res.data.message,
            type: "success",
          });
          this.$showAlert = true;
          window.history.back();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .theme-light .table-dark-bg {
//   // background: $grey-btn-bg;
//   height: calc(100vh - 257px);
//   overflow-x: hidden;
//   overflow-y: auto;
//   @include custom-scrollbar();
// }
// .theme-light .table-dark-bg.full, .theme-dark .table-dark-bg.full{height: calc(100vh - 65px);}
.table-dark-bg {
  height: calc(100vh - 67px);
  overflow-x: hidden;
  overflow-y: auto;
  @include custom-scrollbar();
}
.heading {
  background: $dark-card-title-header !important;
}

.pill {
  border-radius: 5px;
  background: $white-color;
  position: relative;
  &.detail {
    &:hover {
      opacity: 1;
    }
  }
  &.hidden {
    opacity: 0.3;
    &:hover {
      opacity: 0.3;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
  &:before {
    width: 5px;
    height: 100%;
    left: 0;
    top: 0;
    content: "";
    position: absolute;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  .return {
    color: #6699cc;
  }
}

h4 {
  color: $mid-grey;
}
h5 {
  color: $grey-color;
  span {
    color: $dark-card-text;
  }
}

.completed.pill {
  &:before {
    background: $success-btn;
  }
}
.pending.pill {
  &:before {
    background: $danger-dark;
  }
}
.shipped.pill {
  &:before {
    background: $dark-card-text;
  }
}
.completed h6 span {
  color: $success-btn;
}
.action-btns {
  border-radius: 5px;
  &:hover {
    background: #f0f0f0;
  }
}
.input-group-text {
  border: 0;
}
.batch-header {
  background: $dark-card-title-header;
  color: #606060;
  li {
    &:nth-child(1) {
      width: 4%;
      text-align: center;
    }
    &:nth-child(2) {
      width: 14%;
    }
    &:nth-child(3) {
      width: 16%;
    }
    &:nth-child(4) {
      width: 16%;
    }
    &:nth-child(5) {
      width: 17%;
    }
    &:nth-child(6) {
      width: 23%;
    }
    &:nth-child(7) {
      width: 9%;
    }
    .icon {
      cursor: pointer;
    }
    .icon {
      &.collapsed {
        transform: rotate(180deg);
      }
    }
  }
}
.header-btns {
  .btn {
    min-width: 144px;
  }
}
.pill {
  border-radius: 0;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);
  .batch-header {
    background: none;
  }
}
.product-search {
  background-color: #fff;
  position: absolute;
  width: 92%;
  z-index: 9;
}
.theme-dark .product-search {
  background-color: #303030;
}
ul {
  padding: 10px 0px;
  top: -350px;
  height: auto;
  max-height: 350px;
  border-radius: 0px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  overflow-y: auto;
  @include custom-scrollbar();
  margin-bottom: 0px;
}
li {
  width: 100%;
  list-style-type: none;
  padding: 5px 15px;
  border-bottom: 1px $grey-10 solid;
  &:hover {
    background-color: $grey-20;
    // color: #fff;
    cursor: pointer;
  }
  &:last-child {
    border-bottom: transparent !important;
  }
  p {
    font-weight: 300;
    font-size: 0.625rem;
  }
  h6 {
    font-weight: 400;
    font-size: 0.825rem;
    margin: 0px;
  }
  // .row {
  //   display: table;

  //   .col {
  //     display: table-cell;
  //     vertical-align: middle;
  //     color: #000;
  //   }
  // }
}
</style>
